import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { NIST, ZT } from "./ZeroTrustData";
import { PD, statusLookup } from "../DataManagement/DataManagement";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";

function analyzePhase(phase:string){
    const phaseControls = ZT.phaseOrder[phase];
    console.log(PD);
    let phaseData:any = {};
    let d:any = {breakdown: {}, table: []};
    phaseControls.forEach((zid:any) => {
        ZT.ztmap[zid].forEach((nid:any) => {
            const status = PD?.controls?.[nid]?.status || 'None';
            const value = statusLookup[status].score;
            if(!d.breakdown?.[status]) d.breakdown[status] = new Set();
            d.breakdown[status].add(nid);

            if(value === 1) return; // ignore implemented controls
            if(!phaseData?.[nid]) phaseData[nid] = 0;
            phaseData[nid] += 1;

            

        });
    });

    Object.keys(phaseData).forEach((nid:any) => {
        d.table.push({
            'count' : phaseData[nid],
            'nid' : nid,
            'name' : NIST.controls[nid].name,
        })
    })

    return d;
}

export default function ZTPhaseComponent(props:any){
    const [phaseDataTable, setPhaseDataTable] = useState<any>({});
    const dt = useRef<any>(null);

    useEffect(() => {
        if(props.actions.showPhase === '') return;
        const phase = props.actions.showPhase;
        setPhaseDataTable(analyzePhase(phase));

    }, [props.actions.showPhase])

    const exportCSV = (selectionOnly:any) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const header = (
        <h4>Phase {props.actions.showPhase}</h4>
    );

    const tableHeader = (
        <div className="flex d-flex flex-row align-items-center justify-content-between">
            <div>NIST 800-53 Controls - NOT IMPLEMENTED</div>
            <Button type="button" icon="pi pi-file" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" />
            {/* <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" /> */}
            {/* <Button type="button" icon="pi pi-file-pdf" severity="warning" rounded onClick={exportPdf} data-pr-tooltip="PDF" /> */}
        </div>
    );

    return(
        <Dialog header={header} visible={props.actions.showPhase}
                    style={{ width: '75vw', height: 'auto' }}
                    onHide={() => props.dispatch({type: 'update', field: 'showPhase', payload: ''})}
                    modal={false}
                    className=''>
            <div>
                <div style={{display: 'flex', gap: '0.5rem', margin: '0 0 0.5rem 0'}}>
                    {phaseDataTable?.breakdown && 
                        Object.keys(phaseDataTable.breakdown).map((entry:any) => {
                            // console.log(entry, phaseDataTable.breakdown[entry].size)
                            const vname = `${entry} - ${phaseDataTable.breakdown[entry].size}`;
                            const severity = statusLookup?.[entry]?.severity || 'danger';
                            return(
                                <Tag key={`p-${props.actions.showPhase}-${entry}`}
                                    value={vname} severity={severity} rounded style={{textAlign: 'center', padding: '0.5rem', fontSize: '1rem'}}/>
                                    // {entry}: [{phaseDataTable.breakdown[entry].size}] 
                            )
                        })
                    }
                </div>
                <DataTable value={phaseDataTable.table}
                            ref={dt}
                            tableStyle={{ minWidth: '50rem'}}
                            scrollHeight="400px" scrollable 
                            sortField="count" sortOrder={-1}
                            header={tableHeader}
                    >
                    <Column field="count" header="Count" style={{ minWidth: '4rem' }} sortable></Column>
                    <Column field="nid" header="Control" style={{ minWidth: '4rem' }} sortable></Column>
                    <Column field="name" header="Name" style={{ minWidth: '10rem' }}></Column>
                    {/* <Column field="j" header="Justification" style={{ maxWidth: '50%' }}></Column> */}
                </DataTable>
                <div style={{fontWeight: 'bold', fontStyle: 'italic'}}>*Count is number of ZT controls that NIST control will cover</div>
            </div>
        </Dialog>
    );
}